import { render } from "./VueP5.vue?vue&type=template&id=2e0de7f8"
import script from "./VueP5.vue?vue&type=script&lang=js"
export * from "./VueP5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__